import Model from "~/models/_Model";
import Student from "~/models/eschoolplus/registration/Student";
import Update from "./Update";
import dayjs from "dayjs";

export default class Activity extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/mtss";
  }

  // Set the resource route of the model
  resource() {
    return "activities";
  }

  relations() {
    return {
      student: Student,
      updates: Update,
    };
  }

  /**
   * Helper Methods
   */
  getFormattedDate(dateValue, format = "MM/DD/YYYY") {
    if (!dateValue) {
      return null;
    }
    return dayjs(dateValue).format(format);
  }

  /**
   * Helper Attributes
   */
  get display_date_column() {
    return (
      dayjs(this.start_date).format("MM/DD/YYYY") +
      " - " +
      (this.end_date ? dayjs(this.end_date).format("MM/DD/YYYY") : "TBD")
    );
  }

  get display_updated_column() {
    return (
      dayjs(this.updated_at).format("MM/DD/YYYY h:mm:ss A") +
      " by " +
      (this.updated_by ? this.updated_by.display_name : this.updated_by_user)
    );
  }
}
